{
  "columnResizer": "Yeniden sütun boyutlandırıcı",
  "loading": "Yükleniyor...",
  "loadingMore": "Daha fazla yükleniyor...",
  "resizeColumn": "Sütunu yeniden boyutlandır",
  "sortAscending": "Artan Sıralama",
  "sortDescending": "Azalan Sıralama"
}
